var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { staticClass: "disable-select" },
    [
      _vm.isNavigationVisible
        ? _c(
            "v-navigation-drawer",
            {
              attrs: {
                "mobile-break-point": "300",
                persistent: "",
                "mini-variant": _vm.isNavigationDrawerMiniVariant,
                clipped: _vm.navigationClipped,
                "mini-variant-width": "150",
                "enable-resize-watcher": "",
                fixed: "",
                app: ""
              },
              model: {
                value: _vm.showLeftNavigationDrawer,
                callback: function($$v) {
                  _vm.showLeftNavigationDrawer = $$v
                },
                expression: "showLeftNavigationDrawer"
              }
            },
            [
              _c(
                "v-toolbar",
                { attrs: { height: "48" } },
                [
                  _c("span", { staticStyle: { cursor: "default" } }, [
                    _vm._v("Units")
                  ]),
                  _c("v-spacer"),
                  _vm.showLeftNavigationDrawer
                    ? _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              _vm.isNavigationDrawerMiniVariant = !_vm.isNavigationDrawerMiniVariant
                            }
                          }
                        },
                        [
                          _c("v-icon", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.isNavigationDrawerMiniVariant
                                  ? "chevron_right"
                                  : "chevron_left"
                              )
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "v-list",
                { staticClass: "pt-0" },
                _vm._l(_vm.myUnits, function(unit, index) {
                  return _c(
                    "v-list-tile",
                    {
                      key: index,
                      class:
                        unit === _vm.selectedUnit
                          ? "selectedUnitNavigationTile"
                          : "",
                      attrs: { value: "true" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.selectUnitToView(unit)
                        }
                      }
                    },
                    [
                      _c("unit-navigation-tile", {
                        attrs: {
                          unit: unit,
                          useShortName: _vm.isNavigationDrawerMiniVariant,
                          isSelected: unit === _vm.selectedUnit
                        }
                      })
                    ],
                    1
                  )
                })
              )
            ],
            1
          )
        : _vm._e(),
      _vm.isNavigationVisible
        ? _c(
            "v-navigation-drawer",
            {
              attrs: {
                "mobile-break-point": "300",
                right: true,
                clipped: true,
                fixed: "",
                app: ""
              },
              model: {
                value: _vm.showRightNavigationDrawer,
                callback: function($$v) {
                  _vm.showRightNavigationDrawer = $$v
                },
                expression: "showRightNavigationDrawer"
              }
            },
            [_c("legend-drawer")],
            1
          )
        : _vm._e(),
      _vm.isNavigationVisible
        ? _c(
            "v-toolbar",
            {
              staticClass: "ntstAppToolbar",
              attrs: {
                height: "48",
                app: "",
                "clipped-left": _vm.navigationClipped,
                "clipped-right": _vm.navigationClipped
              }
            },
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.showLeftNavigationDrawer = !_vm.showLeftNavigationDrawer
                    }
                  }
                },
                [_c("v-icon", [_vm._v("menu")])],
                1
              ),
              _c(
                "v-toolbar-title",
                { staticClass: "title" },
                [
                  _c(
                    "router-link",
                    { staticStyle: { cursor: "pointer" }, attrs: { to: "/" } },
                    [
                      _c("v-layout", { attrs: { row: "" } }, [
                        _c("img", {
                          staticClass: "titleImage",
                          attrs: {
                            src: require("./assets/images/Netsmart_logo_people_only.png")
                          }
                        }),
                        _c("div", { staticClass: "titleText" }, [
                          _vm._v("BedBoard")
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider", {
                staticClass: "mx-2",
                attrs: { inset: "", vertical: "" }
              }),
              _c("v-spacer"),
              _vm.selectedUnit
                ? _c("unit-navigation-tile", {
                    staticClass: "toolbarSelectedUnitTile",
                    attrs: {
                      unit: _vm.selectedUnit,
                      isSelected: true,
                      useShortName: false
                    }
                  })
                : _vm._e(),
              _c("v-spacer"),
              _vm.selectedUnit
                ? _c(
                    "span",
                    [
                      _c(
                        "v-tooltip",
                        { attrs: { bottom: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "ntstAppIcon",
                              attrs: {
                                slot: "activator",
                                xs: "",
                                icon: "",
                                flat: ""
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  _vm.increaseRoomSize()
                                }
                              },
                              slot: "activator"
                            },
                            [_c("v-icon", [_vm._v("fas fa-plus")])],
                            1
                          ),
                          _c("span", [_vm._v("Make rooms larger")])
                        ],
                        1
                      ),
                      _c(
                        "v-tooltip",
                        { attrs: { bottom: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "ntstAppIcon",
                              attrs: {
                                slot: "activator",
                                xs: "",
                                icon: "",
                                flat: ""
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  _vm.decreaseRoomSize()
                                }
                              },
                              slot: "activator"
                            },
                            [_c("v-icon", [_vm._v("fas fa-minus")])],
                            1
                          ),
                          _c("span", [_vm._v("Make rooms smaller")])
                        ],
                        1
                      ),
                      _c(
                        "v-tooltip",
                        { attrs: { bottom: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "ntstAppIcon",
                              attrs: {
                                slot: "activator",
                                xs: "",
                                icon: "",
                                flat: ""
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  _vm.showUnitAlerts()
                                }
                              },
                              slot: "activator"
                            },
                            [
                              _c("v-icon", [
                                _vm._v("fas fa-exclamation-circle")
                              ])
                            ],
                            1
                          ),
                          _c("span", [_vm._v("View alerts for all stays")])
                        ],
                        1
                      ),
                      _c(
                        "v-tooltip",
                        { attrs: { bottom: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "ntstAppIcon",
                              attrs: {
                                slot: "activator",
                                xs: "",
                                icon: "",
                                flat: ""
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  _vm.showUnitClients()
                                }
                              },
                              slot: "activator"
                            },
                            [_c("v-icon", [_vm._v("fas fa-users")])],
                            1
                          ),
                          _c("span", [_vm._v("View images for all stays")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-tooltip",
                { attrs: { bottom: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ntstAppIcon",
                      attrs: { slot: "activator", xs: "", icon: "", flat: "" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.refreshConfiguration(true)
                        }
                      },
                      slot: "activator"
                    },
                    [_c("v-icon", [_vm._v("fas fa-sync-alt")])],
                    1
                  ),
                  _c("span", [_vm._v("Refresh the data")])
                ],
                1
              ),
              _vm.selectedUnit
                ? _c(
                    "v-tooltip",
                    { attrs: { bottom: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ntstAppIcon",
                          attrs: {
                            slot: "activator",
                            xs: "",
                            icon: "",
                            flat: ""
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              _vm.showRightNavigationDrawer = !_vm.showRightNavigationDrawer
                            }
                          },
                          slot: "activator"
                        },
                        [_c("v-icon", [_vm._v("fas fa-map-signs")])],
                        1
                      ),
                      _c("span", [_vm._v("Legend")])
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-divider", { attrs: { inset: "", vertical: "" } }),
              _c(
                "v-tooltip",
                { attrs: { bottom: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { slot: "activator", xs: "", icon: "", flat: "" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.showUserPreferences()
                        }
                      },
                      slot: "activator"
                    },
                    [_c("v-icon", [_vm._v("settings")])],
                    1
                  ),
                  _c("span", [_vm._v("Preferences")])
                ],
                1
              ),
              _c(
                "v-tooltip",
                { attrs: { bottom: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { slot: "activator", xs: "", icon: "", flat: "" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.showAbout()
                        }
                      },
                      slot: "activator"
                    },
                    [_c("v-icon", [_vm._v("fas fa-info-circle")])],
                    1
                  ),
                  _c("span", [_vm._v("About BedBoard")])
                ],
                1
              ),
              !_vm.isLogoutDisabled
                ? _c(
                    "v-tooltip",
                    { attrs: { bottom: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            slot: "activator",
                            xs: "",
                            icon: "",
                            flat: ""
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              _vm.logout()
                            }
                          },
                          slot: "activator"
                        },
                        [_c("v-icon", [_vm._v("fas fa-sign-out-alt")])],
                        1
                      ),
                      _c("span", [_vm._v("Log out")])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c("v-content", [_c("router-view")], 1),
      _c(
        "v-footer",
        {
          staticClass: "elevation-3",
          staticStyle: { cursor: "default" },
          attrs: { fixed: _vm.isFooterFixed, app: "" }
        },
        [
          _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _c("v-flex", { attrs: { xs3: "" } }),
              _c(
                "v-flex",
                { staticClass: "text-xs-center", attrs: { xs6: "" } },
                [
                  _c("span", { staticClass: "ntstAppFooter" }, [
                    _c("span", [
                      _vm._v(
                        "© Netsmart Technologies, Inc.\n            " +
                          _vm._s(_vm._f("moment")(new Date(), "YYYY"))
                      )
                    ])
                  ])
                ]
              ),
              _c(
                "v-flex",
                { staticClass: "text-xs-right", attrs: { xs3: "" } },
                [
                  _c("span", { staticClass: "versionLabel" }, [
                    _vm._v("BedBoard App " + _vm._s(_vm.appVersion) + " ")
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.isUnitAlertsDialogVisible
        ? _c(
            "v-dialog",
            {
              attrs: { scrollable: "", "min-height": "90%", width: "800px" },
              model: {
                value: _vm.isUnitAlertsDialogVisible,
                callback: function($$v) {
                  _vm.isUnitAlertsDialogVisible = $$v
                },
                expression: "isUnitAlertsDialogVisible"
              }
            },
            [
              _c(
                "v-flex",
                [
                  _c("unit-alerts-card", {
                    attrs: {
                      unit: _vm.selectedUnit,
                      onClose: _vm.closeUnitAlertsDialog
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.isUnitClientsDialogVisible
        ? _c(
            "v-dialog",
            {
              attrs: { scrollable: "", "min-height": "90%", width: "90%" },
              model: {
                value: _vm.isUnitClientsDialogVisible,
                callback: function($$v) {
                  _vm.isUnitClientsDialogVisible = $$v
                },
                expression: "isUnitClientsDialogVisible"
              }
            },
            [
              _c(
                "v-flex",
                [
                  _c("unit-clients-card", {
                    attrs: {
                      unit: _vm.selectedUnit,
                      onClose: _vm.closeUnitClientsDialog
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.isUserPreferencesDialogVisible
        ? _c(
            "v-dialog",
            {
              attrs: { scrollable: "", width: "800px" },
              model: {
                value: _vm.isUserPreferencesDialogVisible,
                callback: function($$v) {
                  _vm.isUserPreferencesDialogVisible = $$v
                },
                expression: "isUserPreferencesDialogVisible"
              }
            },
            [
              _c(
                "v-flex",
                [
                  _c("user-preferences", {
                    attrs: {
                      onCancel: _vm.closeUserPreferencesDialog,
                      onSave: _vm.saveUserPreferences
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.isBusyIndicatorVisible
        ? _c(
            "v-dialog",
            {
              staticStyle: { "overflow-y": "none" },
              attrs: { persistent: "", "min-height": "100px", width: "210px" },
              model: {
                value: _vm.isBusyIndicatorVisible,
                callback: function($$v) {
                  _vm.isBusyIndicatorVisible = $$v
                },
                expression: "isBusyIndicatorVisible"
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "center",
                    "background-color": "#fff",
                    "padding-bottom": "10px"
                  }
                },
                [
                  _c("busy-animation"),
                  _c("div", { staticClass: "ntstLoadingLabel" }, [
                    _vm._v("Loading...")
                  ])
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.isConfigurationErrorDialogVisible
        ? _c(
            "v-dialog",
            {
              attrs: { persistent: "", height: "450px", width: "550px" },
              model: {
                value: _vm.isConfigurationErrorDialogVisible,
                callback: function($$v) {
                  _vm.isConfigurationErrorDialogVisible = $$v
                },
                expression: "isConfigurationErrorDialogVisible"
              }
            },
            [
              _c(
                "v-flex",
                [
                  _c("configuration-error", {
                    attrs: {
                      onLogout: _vm.configurationErrorLogout,
                      onRetry: _vm.retrySelectConfiguration
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }